<template>
  <nav class="generic-faq-tabs" aria-label="Gestion de la FAQ Code du travail">
    <router-link
      v-for="link in links"
      :key="link.path"
      :to="link.path"
      class="generic-faq-tabs__item"
    >
      {{ link.label }}
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'app-dashboard-generic-faq-tabs',
  data () {
    return {
      links: [
        {
          label: 'Questions',
          path: '/app/dashboard/tracking/generic-contents/faq/questions'
        },
        {
          label: 'Activation par domaine',
          path: '/app/dashboard/tracking/generic-contents/faq/domains'
        }
      ]
    }
  }
}
</script>

<style scoped>
.generic-faq-tabs {
  background: #f3f4f6;
  border-radius: 999px;
  display: flex;
  margin-left: auto;
  padding: 4px;
}
.generic-faq-tabs__item {
  background: transparent;
  border: 0;
  border-radius: 999px;
  color: #4b5563;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  padding: 10px 22px;
  text-decoration: none;
  white-space: nowrap;
}
.generic-faq-tabs__item:hover { color: #1d4ed8; }
.generic-faq-tabs__item:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }
.generic-faq-tabs__item.router-link-active {
  background: #2563eb;
  box-shadow: 0 2px 5px rgba(37, 99, 235, .25);
  color: #fff;
}
@media (max-width: 1100px) {
  .generic-faq-tabs { align-self: flex-start; margin-left: 0; max-width: 100%; overflow-x: auto; }
}
</style>
